import React, { useState } from "react";
import { layout1, layout2, layout3, layout4, layout6 } from "../../react-hooks/svgIcons";
import { isMobile } from '../../react-hooks/Utilties';

interface GridSizeSelectorProps {
    setProductsPerRow: (value: string) => void;
}

export const GridSizeSelector: React.FC<GridSizeSelectorProps> = ({ setProductsPerRow }) => {

    const [activeGrid, setActiveGrid] = useState<string>(isMobile ? "two" : "four");

    const handleGridChange = (productsPerRow: string) => {
        setActiveGrid(productsPerRow);
        setProductsPerRow(productsPerRow);
    };

    return (
        <div className="grid-size-selector__container flex justify-center">
            <div className="hidden sm:flex gap-3">
                <span
                    onClick={() => handleGridChange("three")}
                    className={`grid-size-selector__btn ${activeGrid === "three" ? "opacity-1" : "opacity-50"}`}
                >
                    {layout3}
                </span>
                <span
                    onClick={() => handleGridChange("four")}
                    className={`grid-size-selector__btn ${activeGrid === "four" ? "opacity-1" : "opacity-50"}`}
                >
                    {layout4}
                </span>
                <span
                    onClick={() => handleGridChange("six")}
                    className={`grid-size-selector__btn ${activeGrid === "six" ? "opacity-1" : "opacity-50"}`}
                >
                    {layout6}
                </span>
            </div>
            <div className="flex sm:hidden gap-2">
                <span
                    onClick={() => handleGridChange("one")}
                    className={`grid-size-selector__btn ${activeGrid === "one" ? "opacity-1" : "opacity-50"}`}
                >
                    {layout1}
                </span>
                <span
                    onClick={() => handleGridChange("two")}
                    className={`grid-size-selector__btn ${activeGrid === "two" ? "opacity-1" : "opacity-50"}`}
                >
                    {layout2}
                </span>
            </div>
        </div>
    );
};
